let loaded = false;

/** Load display fonts once for historyworm tenant only. */
export function loadHistorywormFonts(tenant: string): void {
  if (tenant !== 'historyworm' || loaded) {
    return;
  }
  loaded = true;
  require('./historywormFonts');
}

/** Test helper */
export function resetHistorywormFontsForTest(): void {
  loaded = false;
}

export function wasHistorywormFontsLoadedForTest(): boolean {
  return loaded;
}
